import { render, staticRenderFns } from "./ThemeConfigurator.vue?vue&type=template&id=510e8fd8&scoped=true&"
import script from "./ThemeConfigurator.vue?vue&type=script&lang=js&"
export * from "./ThemeConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./ThemeConfigurator.vue?vue&type=style&index=0&id=510e8fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e8fd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510e8fd8')) {
      api.createRecord('510e8fd8', component.options)
    } else {
      api.reload('510e8fd8', component.options)
    }
    module.hot.accept("./ThemeConfigurator.vue?vue&type=template&id=510e8fd8&scoped=true&", function () {
      api.rerender('510e8fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/control-center/ThemeConfigurator.vue"
export default component.exports